import React from 'react';
import { useRecoilValue } from 'recoil';
import AccessInfoSelector from '../../recoil/selectors/AccessInfoSelector';

export default function Diamond() {
  const { network } = useRecoilValue(AccessInfoSelector);

  switch (network) {
    case 'meetme':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1559091827329#ic_diamond" /></svg>
      );

    case 'lovoo':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1510677573844#ic_lv_diamond" /></svg>
      );

    case 'vidoo':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1510677573844#ic_vidoo_diamond" /></svg>
      );

    default:
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1510677573844#ic_diamond" /></svg>
      );
  }
}
